export const LoaderState = Object.freeze({
    START: "start",
    STOP:  "stop"
});